import { render, staticRenderFns } from "./ModalAutoCompletarPedido.vue?vue&type=template&id=8ff0e3c8&"
import script from "./ModalAutoCompletarPedido.vue?vue&type=script&lang=js&"
export * from "./ModalAutoCompletarPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports